module.exports = __webpack_public_path__ + "img/delete-button.d46b8c7f.svg";